export const uiModal = {
    name: 'UI Modal',
    description: '',
    displayField: 'title',
    fields: {
        title: {
            name: 'Title',
            type: 'Symbol',
            required: false,
            localized: true,
            disabled: false,
            omitted: false,
            validations: []
        },
        modalTrigger: {
            name: 'Modal trigger',
            type: 'Link',
            linkType: 'Entry',
            required: true,
            localized: false,
            disabled: false,
            omitted: false,
            validations: [{ linkContentType: ['uiButton', 'uiImage'] }]
        },
        modalTriggerBlock: {
            name: 'Modal trigger block',
            type: 'Boolean',
            required: false,
            localized: false,
            disabled: false,
            omitted: false,
            validations: []
        },
        modalContent: {
            name: 'Modal content',
            type: 'Link',
            linkType: 'Entry',
            required: true,
            localized: false,
            disabled: false,
            omitted: false,
            validations: [{ linkContentType: ['uiImage', 'uiVideoPlayer'] }]
        },
        closeText: {
            name: 'Close text',
            type: 'Symbol',
            required: false,
            localized: true,
            disabled: false,
            omitted: false,
            validations: []
        },
        transitionType: {
            name: 'Transition type',
            type: 'Symbol',
            required: false,
            localized: false,
            disabled: false,
            omitted: false,
            validations: [
                {
                    in: [
                        'FadeIn FadeOut',
                        'SlideDown FadeOut',
                        'SlideDown SlideBelow',
                        'ScaleUp ScaleDown',
                        'SlideDown InstantRemove'
                    ]
                }
            ]
        },
        transitionSpeed: {
            name: 'Transition speed',
            type: 'Symbol',
            required: false,
            localized: false,
            disabled: false,
            omitted: false,
            validations: [{ in: ['Slow', 'Medium', 'Fast', 'Instant'] }]
        },
        modalSize: {
            name: 'Modal size',
            type: 'Symbol',
            required: false,
            localized: false,
            disabled: false,
            omitted: false,
            validations: [{ in: ['FitToContent', 'Small', 'Medium', 'Large'] }]
        }
    }
};
//# sourceMappingURL=uiModal.js.map